export const BILLING_HISTORY_DATE = '2024-12-01T00:00:00';
